import { useMutation } from '@tanstack/react-query';

import { postTableRowData } from '../api/portalGateway/postTableRowData';

type UsePostTableRowDataParams = {
  mutationSuccessHandler?: () => void;
  mutationErrorHandler?: () => void;
};

export function usePostTableRowData({
  mutationSuccessHandler,
  mutationErrorHandler,
}: UsePostTableRowDataParams = {}) {
  const { mutateAsync, reset } = useMutation({
    mutationFn: postTableRowData,
    onSuccess: mutationSuccessHandler,
    onError: mutationErrorHandler,
  });

  return {
    reset,
    postTableRowData: (
      contentId: string,
      files: File[],
      data: Record<string, unknown>
    ) => {
      return mutateAsync({ contentId, files, data });
    },
  };
}
